module.exports = __webpack_public_path__ + "static/media/img-cropper.0fdf7271.jpg";